import React, { useState } from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { reportToSegment, types, eventNames } from '@smartcar/morse';
import { IconButton, Menu as MuiMenu, MenuItem, styled, Button, Typography, Divider } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { withRouter } from 'react-router-dom';

import { ACTIONS } from '../../../../../../utils/webhookConfig';

const Menu = styled(MuiMenu)(({ theme }) => ({
  marginTop: '4px',

  '& .MuiList-root': {
    padding: theme.spacing(1),
  },

  '& .MuiMenuItem-root': {
    borderRadius: 0,
    paddingBottom: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  button: {
    color: theme.palette.text.primary,
    width: '100%',
    justifyContent: 'flex-start',
    padding: theme.spacing(1),

    '&:hover': {
      textDecoration: 'none',
      backgroundColor: theme.palette.grey[100],
    },
  },
}));

const ActionMenu = ({
  webhookId,
  selectWebhook,
  actions,
  openModal,
  disabled,
  history,
  applicationId,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (selectWebhook) {
      selectWebhook(webhookId);
    }
    setAnchorEl(event.currentTarget);
    reportToSegment(types.TRACK, eventNames.dropdownOpened, {
      label: 'action creator',
      text: '[webhook actions]',
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewWebhookClick = (whId) => {
    history.push(`/apps/${applicationId}/webhooks/${whId}`);
  };

  const handleViewLogsClick = (whId) => {
    history.push(`/apps/${applicationId}/logs?tab=webhooks&webhookId=${whId}`);
  };

  return (
    <div>
      <IconButton
        id={`webhook-actions-menu-button_${webhookId}`}
        aria-controls={open ? 'webhook-actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size="small"
        sx={{ border: 'none' }}
        data-testid={`webhook-actions-menu-button_${webhookId}`}
        disabled={disabled}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id={`webhook-actions-menu_${webhookId}`}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        MenuListProps={{
          'aria-labelledby': `webhook-actions-menu-button_${webhookId}`,
        }}
        slotProps={{
          paper: {
            style: {
              width: '140px',
            },
          },
        }}
      >
        {actions.map(({ key, text }) => (
          <div key={`${key}_${webhookId}`}>
            {key === ACTIONS.DELETE.key && <Divider />}
            <MenuItem>
              <Button
                onClick={() => {
                  if (key === ACTIONS.VIEW.key) {
                    handleViewWebhookClick(webhookId);
                  } else if (key === ACTIONS.VIEW_LOGS.key) {
                    handleViewLogsClick(webhookId);
                  } else {
                    openModal(key);
                  }
                  handleClose();
                }}
              >
                <Typography variant="body2">{text}</Typography>
              </Button>
            </MenuItem>
          </div>
        ))}
      </Menu>
    </div>
  );
};

export default withRouter(ActionMenu);

ActionMenu.propTypes = {
  webhookId: string.isRequired,
  selectWebhook: func,
  actions: arrayOf(string).isRequired,
  openModal: func.isRequired,
  disabled: bool,
  history: shape({
    push: func.isRequired,
  }).isRequired,
  applicationId: string.isRequired,
};

ActionMenu.defaultProps = {
  selectWebhook: null,
  disabled: false,
};
